import {
  selectPersonnelsStore,
  // selectRequestFormStore,
  useBoundStore,
} from "@/services";
import { size } from "lodash";
// import { VisitDetailsField } from "@/pages/requests/components/visit-details-form/types";

export const useCheckIfPersonnelsStepExist = () => {
  const { personnels } = useBoundStore(selectPersonnelsStore);

  // const { requestFormData } = useBoundStore(selectRequestFormStore);

  // const numberOfPersonnel =
  //   requestFormData?.[VisitDetailsField.NumberOfPersonnel];

  // return size(personnels) > 0 && numberOfPersonnel && +numberOfPersonnel > 0;
  return size(personnels) > 0;
};
